import { BASE_PDF_STYLES } from '../../../../../utils/reportUtils';
import React from 'react';
import ReportButton from '../../../../components/report/ReportButton';

const pdfStyles = `
${BASE_PDF_STYLES}

body.pdfBody .drilldownHeader {
    margin-left: auto!important;
}

body.pdfBody .drilldownContent {
    max-width: 1000px; 
}

`;

type ClaimDrilldownReportProps = {
  elementRef: React.MutableRefObject<HTMLElement | null>;
};

const ClaimDrilldownReport = ({ elementRef }: ClaimDrilldownReportProps) => {
  return (
    <ReportButton
      elementToPrintRef={elementRef}
      fileName="Claim_Drilldown_Report"
      pdfStyles={pdfStyles}
      noButton={true}
      isPdfPortrait={true}
      widthElementID="claim-drilldown"
      minWidth={1000}
      hideExcel={true}
    />
  );
};

export default ClaimDrilldownReport;
